import * as React from 'react';
import { Switch } from '@headlessui/react';
import { InputProps } from 'interfaces';
import { FieldValues, UseFormSetValue } from 'react-hook-form';

export interface ToggleProps {
	isActive: boolean;
	setIsEnabled?: (value: boolean) => void;
	setValue: UseFormSetValue<FieldValues>;
	isDisabled?: boolean;
}

export const Toggle: React.FC<
	ToggleProps & InputProps & React.InputHTMLAttributes<HTMLInputElement>
> = ({
	isActive = false,
	name,
	register,
	rules,
	// setIsEnabled,
	setValue,
	isDisabled,
}) => {
	return (
		<>
			<input
				id={name}
				name={name}
				type="check"
				checked={isActive}
				className="hidden"
				readOnly
				ref={register && register(name, rules).ref}
			/>
			<Switch
				checked={isActive}
				onChange={(checked) => setValue(name, checked)}
				disabled={isDisabled}
				className={`${
					isActive
						? 'bg-primary disabled:bg-[#B18EE0]'
						: 'bg-white border-[1.5px] border-grey-20'
				} relative inline-flex flex-shrink-0 items-center h-5 rounded-full w-8 outline-none focus:outline-none`}
			>
				<span className="sr-only">Enable</span>
				<span
					className={`${
						isActive
							? 'translate-x-[16px] bg-white'
							: 'translate-x-1 bg-grey-20'
					} inline-block w-3 h-3 transform  rounded-full`}
				/>
			</Switch>
		</>
	);
};
